import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function CategorySection() {
  return (
    <section className="max-w-portal mx-auto px-4 md:px-6 pt-12 md:pt-16">
      <SectionHeading
        eyebrow="Content Map"
        title="按幕后类型逛"
        desc="六个方向，把综艺、影视、剧组与剪辑台的幕后故事分门别类，点进去就是完整内容。"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:border-primary-500 hover:bg-primary-50 cursor-pointer"
          >
            <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-foreground-950 text-primary-400 transition-colors group-hover:bg-primary-500 group-hover:text-foreground-950">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <span className="text-xs text-foreground-500">{cat.count} 篇</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mt-1.5 line-clamp-2">
                {cat.desc}
              </p>
            </div>
            <i className="ri-arrow-right-up-line w-5 h-5 shrink-0 flex items-center justify-center text-foreground-400 transition-all group-hover:text-accent-600 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        ))}
      </div>
    </section>
  );
}